<template>
    <FTextfield class="vform17-textfield2" :input.sync="input" :error="component.state=='error'" @blur="handler.action(component, 'set', [input])">
        <template v-slot:label>{{ $vt(component.title) }}</template>
        <template v-slot:helper>{{ $vt(component.description) }}</template>
        <template #action>
            <FIcon v-if="component.state=='valid'" class="checkbutton" icon="fa6-check" />
        </template>
    </FTextfield>
</template>
<script>

import { debounce } from "/vodalys/.jslibs/";

export default {
    props: ['component', 'handler'],
    data() {
        return {
            input: ''
        }
    },
    computed: {
    },
    mounted() {
	
		this.input = this.component ? this.component.text : '';
	
        this.$watch('component.text', (value) => {
            this.input = value
        })
    },
    methods: {
    }

}
</script>
<style lang="scss">
.vform17-textfield2 {
    .checkbutton {
        color: var(--statusPositive);
        padding: 0 8px;
        font-size: 24px;
    }
}
</style>